import React, { useContext, useState } from 'react'
import { Box, Button, Container, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { FiscalYearListType, useInit } from '../DataFetch/useInit';
import { WorkRegistrationType, useWorkRegistration } from '../DataFetch/useWorkRegistration';
import { useErrorDialog } from '../Component/useErrorDialog';
import { GetWorkRegistrationCSV } from '../DataFetch/ManagementAPI';
import { SessionContext } from '../ManagementRoot';
import { SaveCSVWithBOM } from '../Utility/SaveCSVWithBOM';
import { WorkRegistrationEdit } from './WorkRegistrationEdit';

export function WorkRegistration() {

    const {init} = useInit();

    const [currentYear, setCurrentYear] = useState(init?.fiscalyear);

    const {workRegistration, isLoading} = useWorkRegistration(currentYear);

    const {openErrorDialog, ErrorDialog} = useErrorDialog();

    const ConfirmSession = useContext(SessionContext);

    const [editing, setEditing] = useState<boolean>(false);

    const [editData, setEditData] = useState<WorkRegistrationType | undefined>(undefined);

    async function DownloadCSV() {

        if(!await ConfirmSession()) {
            return;
        }

        GetWorkRegistrationCSV(currentYear)
        .then(res => {
            res !== undefined ? SaveCSVWithBOM(`${currentYear}_本登録.csv`, res) : openErrorDialog();
        })
    }

    async function OpenEditor(data:WorkRegistrationType | undefined) {
        
        if(!await ConfirmSession()) {
            return;
        }

        setEditData(data);
        setEditing(true);
    }

    function WorkRegistrationList() {
        return(
            <>
                <TableContainer sx={{maxHeight:500}}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell>作品ID</TableCell>
                                <TableCell>国名</TableCell>
                                <TableCell>メールアドレス</TableCell>
                                <TableCell>グループ</TableCell>
                                <TableCell>グループ人数</TableCell>
                                <TableCell>製品化の興味</TableCell>
                                <TableCell>作品PDFファイル名</TableCell>
                                <TableCell>代表者 名前</TableCell>
                                <TableCell>代表者 生年月日</TableCell>
                                <TableCell>代表者 国名 </TableCell>
                                <TableCell>代表者 教育機関名</TableCell>  
                                <TableCell>代表者 教育機関国名</TableCell>  
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {workRegistration?.map((item:WorkRegistrationType, index:number) => (
                                <TableRow key={index} hover onClick={() => OpenEditor(item)}>
                                    <TableCell>{item.artwork_id}</TableCell>
                                    <TableCell>{item.country_name}</TableCell>
                                    <TableCell>{item.mailaddress}</TableCell>
                                    <TableCell>{item.group_flg}</TableCell>
                                    <TableCell>{item.group_num}</TableCell>
                                    <TableCell>{item.interest_work}</TableCell>
                                    <TableCell>{item.pdf_file_name}</TableCell>
                                    <TableCell>{item.poster1}</TableCell>
                                    <TableCell>{item.birthday1}</TableCell>
                                    <TableCell>{item.country_name1}</TableCell>
                                    <TableCell>{item.educational_institution1}</TableCell>
                                    <TableCell>{item.educational_institution_country_name1}</TableCell>
                                </TableRow>
                            ))} 
                        </TableBody>
                    </Table>
                </TableContainer>
            </>
        );
    }

    function WorkRegistrationListWindow() {
        return(
            <>
                <Grid2 xs={12}>
                    <Paper>
                        <Container maxWidth="sm">
                            <Box p={2}>                         
                                <Typography
                                    variant="body1"
                                    p={1}
                                >
                                    対象年度
                                </Typography>
                                <Select
                                    defaultValue={init?.fiscalyear.toString()}
                                    onChange={e => e.target.value !== currentYear ? setCurrentYear(e.target.value) : ""}
                                    value={currentYear}
                                >
                                    {
                                        init?.fiscal_year_list.map((value:FiscalYearListType, index:number) =>(
                                            <MenuItem key={index} value={value.target_year}>
                                                {value.target_year}
                                            </MenuItem>
                                        ))
                                    }
                                </Select>
                                <Box p={2}>
                                    <Button variant="contained" onClick={DownloadCSV}>
                                        ダウンロード
                                    </Button>
                                </Box>                    
                            </Box>
                        </Container>
                    </Paper>
                </Grid2>
                <Grid2 xs={12}>
                    <Paper sx={{overflow:"hidden", whiteSpace:"nowrap"}}>
                        {!isLoading ? WorkRegistrationList() : ""}
                    </Paper>
                </Grid2>
            </>
        );
    }

    function EditWindow() {
        return(
            <>
                <Grid2 xs={12}>
                    <Paper>
                        <Box m={2} p={1}>
                            <WorkRegistrationEdit
                                editData={editData}
                                setEditing={setEditing}
                            />
                        </Box>
                    </Paper>
                </Grid2>
            </>
        );
    }

    return(
        <>
            <Typography
                variant="h6"
            >
                本登録
            </Typography>
            
            {editing ? <EditWindow/> : <WorkRegistrationListWindow/>}

            <ErrorDialog/>
        </>
    );
}